module.exports = __webpack_public_path__ + "static/img/kx1-3.7b0239a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kx1-3.png
// module id = 752
// module chunks = 0